import z, { object, string, nativeEnum, boolean, array } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import {
  Offer_Funding_Source,
  Offer_Presentation_Priority,
  Offer_Presentation_Type,
} from '@occc/graphql';
import { marketingContentSchema } from '@occc-app/offerHelpers/DesignForm/validation';
import { CustomDataSchema } from '@occc/validation';

// TODO: After offerHelpers will be refactored and migrated to zod we have to
// export designFormSchema and DesignFormValues from offerHelpers to avoid duplication

const designFormSchema = object({
  offer: object({
    id: string(),
    fundingSource: nativeEnum(Offer_Funding_Source).nullable().optional(),
    fundingSourceName: string().nullable().optional(),
    presentationType: nativeEnum(Offer_Presentation_Type).optional(),
    presentationPriority: nativeEnum(Offer_Presentation_Priority).optional(),
    displayForOrderAhead: boolean().optional(),
  }).optional(),
  marketingContent: marketingContentSchema.default({}),
  // Mirrors the shared offerHelpers design-form schema. Display categories are
  // only configurable for awards using the Tile (Default) layout; the field is
  // hidden and cleared for any other layout type.
  displayCategories: array(
    object({
      id: string(),
      name: string(),
    }),
  ).default([]),
  customData: CustomDataSchema,
});

export type DesignFormValues = z.infer<typeof designFormSchema>;

export const validateDesignForm = makeValidate(designFormSchema);
